<template>
  <div class="v3-scene">

    <!-- Left -->
    <div class="v3-scene-3col special-col">
      <div>
        <div class="chko-header v4-section-header-light color-fblue" style="margin-top: 0.5em; font-weight: 600; font-size: 2.5em">Chicago Discovery Day</div>
        <p class="v4-section-header-light color-storm chko-content" style="margin-top: 0.5em">
          We are delighted to invite you to enjoy specialty cocktails and light bites on a 45 minute cruise departing from Navy Pier or choose to attend our Chicago Kick-off Party that evening from 4:30pm to 7:30pm! Learn about the Club and experience all that we have to offer you, your friends and family this summer.
        </p>
      </div>
      <img alt="Lounging on the bow of a B&G Daychaser" class="center-mobile" style="width: 440px;" src="https://cloud.bartonandgray.com/library/activities/events/chko-2025/bg-dc-pb-lifestyle-bow 1.jpg">
    </div>

    <!-- Middle -->
    <div class="v3-scene-3col">
      <div class="center-mobile"  style="">
        <img alt="B&G vessels in Oyster Bay" class="center-mobile" style="width: 440px;" src="https://cloud.bartonandgray.com/library/activities/events/chko-2025/bg-fleet-osterville-aerial.jpg">
      </div>
      <p class="v4-section-header-light color-storm chko-content" style="">
        <span style="font-weight: 600;">Learn About The Club</span><br>
        Considered one of the most unique Clubs in North America, Barton & Gray Mariners Club outfits the best experiences on the water, operating a fleet of captained Daychasers, Hinckleys, Sailing Catamaran & Boston Whalers from The Great lakes, to New England and down to the Florida Coasts. All captained, all provisioned and all at your beck and call, Members enjoy a lifetime of yachting with unlimited access to every yacht in every harbor.
      </p>

      <!-- Button -->
      <div class="" style="margin: 1.5em 0; width: 360px; max-width: 100%;">
        <a href="/membership-home">
          <div class="v3-button-bright shadow" style="width: 100%; max-width: 360px; justify-content: left;">
            <img src="https://cloud.bartonandgray.com/library/brand/burgee-pole.svg">
            <div class="v3-button-mini-label">Learn about Membership Here</div>
          </div>
        </a>
      </div>
    </div>

    <!-- Right -->
    <div class="v3-scene-3col">
      <div class="schedule-holder bgcolor-gold" style="padding: 2em 3em">
        
        <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: flex-start;">
          <div class="color-storm" style="font-size: 2.25em; font-weight: 700; line-height: 1;">Discovery Day Details</div>
          <img alt="B&G Event Icon" style="width: 81px;" src="https://cloud.bartonandgray.com/library/activities/events/chko-2025/event-icon.png">
        </div>

        <div class="v4-section-header-light color-fblue" style="margin-top: 1em; margin-bottom: 1em; text-align: left; font-size: 1.875em;">Saturday, June 21st</div>

        <!-- Where -->
        <div class="color-storm" style="font-size: 1.875em; font-weight: 700;">Where</div>
        <p class="v4-section-header-light color-storm" style="font-size: 1.25em; margin-top: 0;">The Navy Pier Barton &amp; Gray Docks</p>

        <!-- When -->
        <div class="color-storm" style="font-size: 1.875em; font-weight: 700;">When</div>
        <p class="v4-section-header-light color-storm" style="font-size: 1.25em; margin-top: 0; font-weight: 600; margin-bottom: 0.5em;">Discovery Cruises:</p>
        <p class="v4-section-header-light color-storm" style="font-size: 1.25em; margin-top: 0;">Saturday, June 21st<br>10:00am to 3:00pm</p>

        <p class="v4-section-header-light color-storm" style="font-size: 1.25em; margin-top: 0; font-weight: 600; margin-bottom: 0.5em;">Chicago Kick-Off Party:</p>
        <p class="v4-section-header-light color-storm" style="font-size: 1.25em; margin-top: 0;">Saturday, June 21st<br>5:00pm to 7:00pm</p>

        <!-- Who -->
        <div class="color-storm" style="font-size: 1.875em; font-weight: 700;">Who</div>
        <p class="v4-section-header-light color-storm" style="font-size: 1.25em; margin-top: 0;">Mingle with Barton & Gray Members, Partners and Friends</p>

        <!-- What to expect -->
        <div class="color-storm" style="font-size: 1.875em; font-weight: 700;">What to expect</div>
        <p class="v4-section-header-light color-storm" style="font-size: 1.25em; margin-top: 0.5em;">
          Enjoy our specialty cocktails and light bites on a 45 minute cruise during the day to experience what it is like being a B&G Member.
          <br>
          <br>
          Or that evening, whether you just want to relax and listen to the live music or bring the kids to play some corn hole. Enjoy light bites while enjoying our pop up Dock Lounge. The Naughty Bar will be available on-board one of our Hinckley Talaria's, offering all of our standard libations.
        </p>

        <!-- Button -->
        <div class="" style="margin: 1.5em 0; width: 360px; max-width: 100%;">
          <a href="https://www.bartonandgray.com/events/2025/chicago-discovery-day">
            <div class="v3-button-bright shadow" style="width: 100%; max-width: 360px; justify-content: left;">
              <img src="https://cloud.bartonandgray.com/library/brand/burgee-pole.svg">
              <div class="v3-button-mini-label">RSVP TODAY!</div>
            </div>
          </a>
        </div>

      </div>
    </div>
  </div>
</template>

<script setup>

</script>

<style scoped lang="scss">

.v3-scene{
  gap: 1em;
  @media only screen and (max-width: 1280px){
    padding: 0 1em;
  }
}

.v3-scene-3col, .v3-scene-2-3col{
  @media only screen and (max-width: 1280px){
    width: 480px !important;
  }
}

img{
  max-width: 100%;
}

.chko-content{
  font-size: 1.875em;
}

.alternate-mobile{
  @media only screen and (max-width: 1280px){
    flex-direction: column-reverse;
  }
}

.special-col{
  display: flex;
  flex-direction: column;

  @media only screen and (max-width: 1280px){
    flex-direction: column-reverse;
  }
}

.center-mobile{
  @media only screen and (max-width: 1280px){
    margin: 0 auto !important;
    display: flex !important;
    justify-content: center !important;
  }
}

</style>